var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"xKyxHepyZ5nK-Yyvo8qS6"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

  // % of transactions captured for performance monitoring (0.1 = 10%).
  // Lowered from 1.0 to trim per-request tracing overhead.
  tracesSampleRate: 0.1,

  // Only run Sentry in production
  enabled: process.env.NODE_ENV === "production",

  // Ignore errors from browser extensions and in-app browsers
  ignoreErrors: [
    "Object Not Found Matching Id",
    "Non-Error promise rejection captured",
    "_AutofillCallbackHandler",
    "Failed to connect to MetaMask",
    "MetaMask extension not found",
    "Loading CSS chunk",
    "Loading chunk",
    "Java object is gone",
    "options is not defined",
    // Facebook in-app browser injects inject_content.js which breaks document.createEvent context
    "Illegal invocation",
    // Factors.ai SDK throws this in Mobile Safari due to ITP blocking identity resolution
    "No user.",
  ],

  // Suppress errors originating from Facebook IAB injected scripts and LeadFeeder tracker
  denyUrls: [
    /^app:\/\/\//i,               // Android WebView / Facebook IAB injected scripts
    /sc\.lfeeder\.com\/lftracker/i, // LeadFeeder tracker
    /redditstatic\.com\/ads\/pixel/i, // Reddit Pixel
  ],

  // Filter out errors from bots, crawlers, browser extensions, and third-party scripts
  beforeSend(event, hint) {
    const ua = event.request?.headers?.["User-Agent"] || "";
    if (/HeadlessChrome|PhantomJS|Googlebot|bingbot|Baiduspider/i.test(ua)) {
      return null;
    }

    // Drop errors from browser extensions and third-party injected scripts
    const frames = event.exception?.values?.[0]?.stacktrace?.frames || [];
    const hasExtensionFrame = frames.some((frame) => {
      const filename = frame.filename || "";
      return (
        filename.startsWith("app:///") ||
        filename.includes("inject_content") ||
        filename.includes("lftracker") ||
        filename.includes("extensions/") ||
        filename.startsWith("chrome-extension://") ||
        filename.startsWith("moz-extension://")
      );
    });
    if (hasExtensionFrame) {
      return null;
    }

    // Drop Swiper internal errors (race condition during SPA navigation)
    const errorMessage = hint?.originalException?.message || event.exception?.values?.[0]?.value || "";
    if (errorMessage.includes("slidesPerGroupSkip")) {
      return null;
    }

    return event;
  },
});
